import clsx from 'clsx';
import { i18n } from '@lingui/core';
import { TableCell } from '@material-ui/core';
import { isNil, isString } from 'lodash';

import { SIZED_CELL_CLASS, INNER_CELL_VALUE_CLASS } from '../DataTableConstants';

/**
 * @typedef {import('@material-ui/core').TableCellProps & {
 *      tooltip?: string | object
 *      column: object
 * }} ColumnCellProps
 */

/**
 * @param {ColumnCellProps} props
 */
export default function ColumnCell(props) {
    const { column, className, tooltip, ...restProps } = props;
    const { width, align } = column;

    const tooltipProps = {};

    if (!isNil(tooltip)) {
        try {
            tooltipProps.title = i18n._(tooltip);
        } catch (ex) {
            if (isString(tooltip)) {
                tooltipProps.title = tooltip;
            } else {
                throw ex;
            }
        }
    }

    return (
        <TableCell
            {...restProps}
            {...tooltipProps}
            className={clsx(SIZED_CELL_CLASS, INNER_CELL_VALUE_CLASS, className)}
            style={{ width: `${width}px` }}
            align={align}
            component="div"
            size="small"
        />
    );
}
